import { SET_DATA, SET_ERROR, SET_ITEMS, RESET } from '../mutation-types'
import axios from 'axios'
import Vue from 'vue'

const SET_CHART = 'SET_CHART'
const CLEAR = 'CLEAR'
const SET = 'SET'

const MODEM_SETS_DEFAULT = {
    dp_pos_cash: null,
    dp_pos_cashless: null,
    scale_cash: null,
    scale_cashless: null,
    sound: null,
    cashless_mode: null,
    cashless_address: null
}

export default {
    namespaced: true,

    state: {
        data: {},
        error: null
    },

    getters: {
        loading: state => state.loading.data,

        sets: state => {
            const sets = { ...MODEM_SETS_DEFAULT, ...state.data.modem_sets || {} }

            Object.keys(state.data.modem_settings || []).forEach(key => {
                if (key in sets && (sets[key] == null || sets[key].length === 0) && state.data.modem_settings[key]) {
                    sets[key] = state.data.modem_settings[key]
                }
            })

            return sets
        },

        settings: state => state.data.modem_settings || {}
    },

    mutations: {
        [CLEAR](state) {
            state.data = {}
            state.error = null
        },

        [SET_DATA](state, data) {
            state.data = { ...state.data, ...data }

            if (state.data.modem_sets === undefined) {
                state.data.modem_sets = {}
            }
        },

        [SET_ERROR](state, error = null) {
            state.error = error
        },

        [SET](state, { key, value }) {
            if (value == null || value.length === 0) {
                value = MODEM_SETS_DEFAULT[key] || null
            }

            Vue.set(state.data.modem_sets, key, value)
        }
    },

    actions: {
        async set({ commit }, { key, value }) {
            commit(SET, { key, value })
        },

        async fetch({ commit }, id) {
            if (!id) {
                return null
            }

            try {
                let response = await axios.get(`api/vms/${id}`, { params: { with_modem: 1, loading: 1 } })
                commit(SET_DATA, response.data)
                // commit(SET_DATA, [], { module: 'loading' })
            } catch (error) {
                return true
            }

            return true
        },

        async save({ commit, getters }, vm) {
            commit(SET_ERROR)

            const data = { ...vm, modem_sets: getters.sets }

            try {
                const response = vm.id
                    ? await axios.put(`api/vms/${vm.id}`, data)
                    : await axios.post(`api/vms`, data)

                commit(SET_DATA, response.data)
            } catch (error) {
                if (error.response.status === 422) {
                    commit(SET_ERROR, error.response.data || {})
                }

                return false
            }

            return true
        },

        async applyPlanogram({ commit }, { vm_id, planogram_id }) {
            try {
                await axios.post(`api/vms/${vm_id}/planogram`, { planogram_id })
            } catch (error) {
                return false
            }

            return true
        }
    },

    modules: {
        loading: {
            namespaced: true,

            state: {
                data: []
            },

            mutations: {
                [SET_DATA](state, data) {
                    state.data = data
                }
            },

            actions: {
                async fetch({ commit }, id) {
                    try {
                        const response = await axios.get(`api/vms/${id}/layout`)
                        commit(SET_DATA, response.data.capacity)
                    } catch (error) {
                        return false
                    }

                    return true
                },

                async save({ commit }, { vmId, loading }) {
                    try {
                        const response = await axios.post(`api/vms/${vmId}/loading`, loading)
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        vends: {
            namespaced: true,

            state: {
                data: [],
                meta: null,

                chart: []
            },

            actions: {
                async fetchChart({ commit }, { id, params }) {
                    try {
                        const response = await axios.get(`api/vends-chart`, { params: { vm_id: id, ...params } })
                        commit(SET_CHART, response.data)
                    } catch (error) {
                        return false
                    }
                },

                async load({ state, commit }, { id, params }) {
                    let page = 1
                    let last_page = 2

                    if (state.meta) {
                        page = state.meta.current_page + 1
                        last_page = state.meta.last_page
                    }

                    if (page > last_page) {
                        return
                    }

                    try {
                        const response = await axios.get(`api/vends`, { params: { vm_id: id, ...params, page } })
                        const { data, meta } = response.data

                        commit(SET_ITEMS, { data, meta })

                        return meta.last_page > meta.current_page
                    } catch (error) {
                        return false
                    }
                },

                async reset({ commit }) {
                    commit(RESET)
                }
            },

            mutations: {
                [RESET](state) {
                    state.data = []
                    state.meta = null
                },

                [SET_ITEMS](state, { data, meta }) {
                    state.data.push(...data)
                    state.meta = meta
                },

                [SET_CHART](state, chart) {
                    state.chart = chart
                }
            }
        },

        correction: {
            namespaced: true,

            state: {
                error: null
            },

            mutations: {
                [SET_ERROR](state, error = null) {
                    state.error = error
                }
            },

            actions: {
                async save({ commit }, { id, payload }) {
                    try {
                        await axios.post(`api/vms/${id}/correction`, payload)

                        return true
                    } catch (error) {
                        if (error.response.status === 422) {
                            commit(SET_ERROR, error.response.data || {})
                        }

                        return false
                    }
                }
            }
        }
    }
}
